import { makeStyles, Slide, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'src/app/i18n';
import { MainUnderlineButton } from 'src/components/buttons/MainButton';
import Footer from 'src/components/layouts/Footer';
import { useBlogState } from './BlogProvider';
import { useBlogGraphql } from './services/blog.graphql';

interface Props {
    children: React.ReactNode;
}

const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 600,
        marginBottom: theme.spacing(8),
        textAlign: 'center',
        marginTop: theme.spacing(10)
    },
    textButton: { color: theme.palette.primary.light, fontWeight: 600 },
    button: { marginBottom: theme.spacing(10), alignSelf: 'center' },
    blogContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: `${theme.spacing(10)}px ${theme.spacing(5)}px`
    },
    bottom: { display: 'flex', flexDirection: 'column' }
}));

const BlogFooterTitle = ({ children }: Props) => {
    const { t } = useTranslation('blog');
    const classes = useStyles();
    const { closeDetail } = useBlogState();
    useBlogGraphql();
    // useEffect(() => {
    //     dispatch(appendBlog(blogs));
    // }, [dispatch]);
    return (
        <>
            <Slide direction="left" in={!closeDetail}>
                <div>
                    <Typography className={classes.title} color="textPrimary" variant="h5">
                        {t('title')}
                    </Typography>
                </div>
            </Slide>
            <div className={classes.blogContainer}>{children}</div>
            <Slide direction="left" in={!closeDetail}>
                <div className={classes.bottom}>
                    <br />
                    <br />

                    <MainUnderlineButton
                        // onClick={() => dispatch(appendBlog(blogs))}
                        className={classes.button}
                        textProp={{ className: classes.textButton }}>
                        {t('olderPost')}
                    </MainUnderlineButton>
                    <Footer variant="black" />
                </div>
            </Slide>
        </>
    );
};

export default BlogFooterTitle;
